/**
 * External dependencies
 */
import * as React from 'react';
import { useFeature } from 'flagged';
import { __ } from '@web-stories-wp/i18n';

/**
 * Internal dependencies
 */
import { SimplePanel } from '../../panel';
import DropShadowControls from './dropShadow';
import TextDepthControls from './textDepth';
import TextInnerGlowControls from './textInnerGlow';
import Flags from '../../../../flags';
import type { PanelProps } from '../../types';
import type { TextElement } from '@src/web-stories-wp/story-editor/src/elements/types';

function StylePanel(props: PanelProps<TextElement>) {
  const canEditTextEffects = useFeature(Flags.USE_STUDIO_TEXT_EFFECTS) === true;
  return (
    <SimplePanel
      name="effects"
      title={__('Effects', 'web-stories')}
      isPersistable
    >
      <DropShadowControls {...props} />
      {canEditTextEffects && (
        <>
          <TextDepthControls {...props} />
          <TextInnerGlowControls {...props} />
        </>
      )}
    </SimplePanel>
  );
}

export default StylePanel;
